// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1nM0J","tab":"ProcedureTabs_tab__3JFCp"};